const statAct = {
  SET_EXPDATA: "SET_EXPDATA",
  SET_HEADERCOLS: "SET_HEADERCOLS",
  SET_FILENAME: "SET_FILENAME",
};

export default statAct;
